import VisibilitySensor from 'react-visibility-sensor'

import { readyToLoad } from 'app/components/common/reports/v3/hooks/useLazyLoading'

type Props = {
  value: string
  lastRow: boolean
}

export const CellLoadingController = ({ value, lastRow }: Props) => {
  const handleVisible = (visible: boolean) => {
    if (visible) {
      readyToLoad()
    }
  }

  const result = <span>{value}</span>

  return lastRow ? (
    <VisibilitySensor onChange={handleVisible} partialVisibility delayedCall>
      {result}
    </VisibilitySensor>
  ) : (
    result
  )
}
